import type { AgencyServiceRow, PackageServiceLine, SystemCapabilityKey } from '../../api/types';

export const INFLUENCER_COMMERCIAL_SURFACES_ENABLED = false;

export function isCommercialCapabilityVisible(key: SystemCapabilityKey): boolean {
  return INFLUENCER_COMMERCIAL_SURFACES_ENABLED || key !== 'influencers';
}

export function isAgencyServiceVisible(
  service: Pick<AgencyServiceRow, 'system_capability_key' | 'capability_keys'>,
): boolean {
  return (
    INFLUENCER_COMMERCIAL_SURFACES_ENABLED ||
    (service.system_capability_key !== 'influencers' &&
      !service.capability_keys.includes('influencers'))
  );
}

export function isPackageServiceLineVisible(
  service: Pick<PackageServiceLine, 'system_capability_key'> & {
    readonly capability_keys?: ReadonlyArray<SystemCapabilityKey>;
  },
): boolean {
  return (
    INFLUENCER_COMMERCIAL_SURFACES_ENABLED ||
    (service.system_capability_key !== 'influencers' &&
      !service.capability_keys?.includes('influencers'))
  );
}
